<template>
  <div class="Activity__Component">
    <div class="Activity__Component__Tabs">
      <div class="Activity__Component__Tabs__Item" @click="loadQuestion()" :class="{ active: tab === 1 }">
        עריכה
      </div>
      <!-- <div class="Activity__Component__Tabs__Item" @click="loadQuestionItems()" :class="{ active: tab === 2 }">
        שאלות בתרגול
      </div> -->
    </div>
    <div class="Activity__Component__TabsContent">
      <!-- <new-activity ref="noteActivity" v-if="showNewNote" type="Note" @onClose="close" @onSave="saveNote" />
      <new-activity ref="taskActivity" v-if="showNewTask" type="Task" show-title="true" @onClose="closeTask"
        @onSave="saveTask" /> -->
      <template v-if="isLoading">
        <div class="loading">
          <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="false" />
        </div>
      </template>
      <div v-if="tab === 1">
        <div class="Activity__Component__TabsContent__Tasks">
          <div v-if="question" class="Activity__Component__TabsContent__Tasks__Content">

            <div class="item">
              <h1 class="bold-text" style="display: flex">נתוני חכמת ההמונים</h1>
              <div class="question-details">
                <div class="question-detail">
                  <b-icon title="1- הכי קלה, 10-הכי קשה. נתון זה מתבסס על חכמת ההמונים" pack="fa"
                    icon="exclamation"></b-icon>
                  <p>רמת קושי: {{ question.difficultyLevel }} ({{ studentAnswers.difficultyPercentage }}% הצלחה)</p>
                </div>
                <div class="question-detail">
                  <b-icon title="כמות משיבים כללית לשאלה זו" pack="fa" icon="exclamation"></b-icon>
                  <p>כמות משיבים: {{ studentAnswers.studentAnswersCount }}</p>
                </div>
                <div class="question-detail">
                  <b-icon title="זמן ממוצע נטו למענה על שאלה זו" pack="fa" icon="exclamation"></b-icon>
                  <p v-if="studentAnswers.averageQuestionTime && question.averageQuestionTime">זמן ממוצע למענה: {{
                    parseTime(studentAnswers.averageQuestionTime) }}
                  </p>
                </div>
              </div>
              <div class="question-details">
                <div class="question-detail">
                  <b-icon pack="fa" icon="exclamation"></b-icon>
                  <p>אחוז סימוני כוכבית: {{ studentAnswers.starPercentage }}%</p>
                </div>
                <div class="question-detail">
                  <b-icon pack="fa" icon="exclamation"></b-icon>
                  <p>ציון כוכבית: {{ studentAnswers.starGrade || 'אין נתונים' }}</p>
                </div>
                <div class="question-detail">
                  <b-icon pack="fa" icon="exclamation"></b-icon>
                  <p>אחוז אפורות: {{ studentAnswers.grayPercentage }}</p>
                </div>
                <div class="question-detail">
                  <b-icon pack="fa" icon="exclamation"></b-icon>
                  <p>ציון אפורות: {{ studentAnswers.grayGrade }}</p>
                </div>
              </div>
            </div>

            <div class="item">
              <div style="display: flex; gap: 20px;">
                <b-field style="width: 100%;" label="סטטוס:">
                  <FieldInlineSelect :hideHover="true" style="border: 1px solid gray; width: 100%;" :filterable="true"
                    :clearable="true" :options="[{ Value: false, Text: 'לא פעיל' }, { Value: true, Text: 'פעיל' }]"
                    v-model="question.status" />
                </b-field>
                <b-field style="width: 100%;" label="מוסד:">
                  <FieldInlineSelect :hideHover="true" style="border: 1px solid gray; width: 100%;" :filterable="true"
                    :clearable="true" :optionsAsync="getAcademicInstitudes" v-model="question.academicInstitutionId" />
                </b-field>
                <!-- <b-field style="width: 100%;" label="מחבר:">
                  <FieldInlineSelect :hideHover="true" style="border: 1px solid gray; width: 100%;" :filterable="true"
                    :clearable="true" :optionsAsync="getAuthors" v-model="question.authorId" />
                </b-field> -->
                <div style="width: 100%;">
                  <b-field style="width: 100%;" label="נוצר על ידי:">
                    <div>{{ question.creatorUserName }} ({{ parseDate(question.createdDate) }})</div>
                  </b-field>
                  <a @click="openQuestionHistory">היסטוריית עריכה</a>
                </div>
              </div>
            </div>

            <div class="item">
              <div style="display: flex; gap: 20px;">
                <b-field style="width: 100%;" label="סוג שאלה:">
                  <FieldInlineSelect :hideHover="true" style="border: 1px solid gray; width: 100%;" :filterable="true"
                    :clearable="true"
                    :options="[{ Value: 1, Text: 'Default' }, { Value: 4, Text: 'טקסט' }, { Value: 5, Text: 'YesNo' }, { Value: 6, Text: 'כרטיסייה' }]"
                    v-model="question.exerciseQuestionTypeId" />
                </b-field>
                <b-field style="width: 100%;" label="שם שאלה:">
                  <input type="text" style="border: 1px solid gray; width: 100%; padding: 14px;" v-model="question.name"
                    name="" id="">
                </b-field>
                <b-field style="width: 100%;" label="תיאור קצר:">
                  <input type="text" style="border: 1px solid gray; width: 100%; padding: 14px;"
                    v-model="question.questionDescription" name="" id="">
                </b-field>
                <b-field style="width: 100%;" label="קטגוריות:">
                  <!-- <FieldInlineSelect :multiple="true" :hideHover="true" style="border: 1px solid gray; width: 100%;"
                    :filterable="true" :clearable="true" :optionsAsync="getCategories"
                    v-model="question.exerciseCategoryIds" /> -->
                  <!-- <v-select dir="rtl" label="Text" v-model="question.questionCategoryIds" :filterable="true"
                    :clearable="true" :reduce="item => item.Value" :getOptionLabel="(item) => `${item.Text}`"
                    :options="categories" :multiple="true" :searchable="true" :close-on-select="false"
                    :placeholder="'בחר ערך מהרשימה'"> </v-select> -->
                    <TreeSelect
                    v-model="question.questionCategoryIds"
                    :options="treeCategories"
                    />
                </b-field>
              </div>
            </div>

            <div class="item">
              <div style="display: flex; align-items: center;">
                <b-field style="width: 50%" label="סוג אפקט בשאלה:">
                  <FieldInlineSelect v-if="question.exerciseQuestionTypeId !== 6" key="effect-types" :hideHover="true" style="border: 1px solid gray; width: 100%;" :filterable="true"
                    :clearable="true" :options="getEffectTypes" v-model="question.effectId" />
                  <FieldInlineSelect v-if="question.exerciseQuestionTypeId === 6" key="flip-card" :hideHover="true" style="border: 1px solid gray; width: 100%;" :filterable="true"
                    :clearable="true" :options="getOptionsForFlipCardEffect" v-model="flipCardEffectId"/>
                </b-field>
                <b-checkbox class="bold-text" v-model="question.isHideAnswers">הסתרת חלופות כדיפולט?</b-checkbox>
              </div>
            </div>

            <div class="item">
              <b-field label="שאלה">
                <template>
                  <!-- <ckeditor :editor="editor" v-model="question.question" :config="editorConfig"></ckeditor> -->
                  <NewActivityEditor @onEditorChange="setQuestion" v-if="ready" :ckEditorContent="question.question"
                    :content="question.question" ref="question" />
                </template>
              </b-field>
            </div>

            <div class="item">
              <b-field label="תשובה מפורטת">
                <template>
                  <!-- <ckeditor :editor="editor" v-model="question.detailedAnswer" :config="editorConfig"></ckeditor> -->
                  <NewActivityEditor @onEditorChange="setDetailed" v-if="ready" :ckEditorContent="question.detailedAnswer"
                    :content="question.detailedAnswer" ref="detailedAnswer" />
                </template>
              </b-field>
            </div>

            <!-- כרטיסייה -->
            <template v-if="question.exerciseQuestionTypeId === 6">
              <div class="item">
                <b-checkbox class="bold-text" v-model="showVideoInFrontCard" @input="toggleShowVideoInFrontCard">הצג וידאו בחזית הכרטיסייה</b-checkbox>
                <div class="item" v-if="showVideoInFrontCard && frontCardVideoItem">
                  <b-field label="קישור לוידאו הכרטיסייה:">
                    <FieldInlineSelect  :fetch-options="getVideos" v-model="frontCardVideoItem.videoId" :initial-option="videoLabelCache[frontCardVideoItem.videoId]"/>
                  </b-field>
                </div>
              </div>
              <!-- כל התוכן של הגב -->
              <div v-if="backSideItems.length > 0 && flipCardEffectId === 2" class="flip-card-back-container">
                <h3 class="flip-card-item-side">גב הכרטיסייה</h3>
                <div v-for="(flipCardItem, idx) in backSideItems" :key="`back-${idx}`">
                  <div v-if="flipCardItem.contentTypeId === 1" class="flip-card-back-side-content-item">
                    <b-field label="טקסט:" style="flex: 1;">
                      <NewActivityEditor 
                        v-if="ready"
                        @onEditorChange="(e) => flipCardItem.textContent = e" 
                        :ckEditorContent="flipCardItem.textContent"
                        :content="flipCardItem.textContent" 
                        ref="editor"
                      />
                    </b-field>
                    <b-field label="סדר:" style="min-width: 120px;">
                      <input type="number" style="border: 1px solid gray; width: 100%; padding: 10px;" v-model.number="flipCardItem.sortOrder">
                    </b-field>
                    <b-button class="remove-item-btn" @click="removeContentFromBackOfCard(flipCardItem)">הסר תוכן</b-button>
                  </div>
                  
                  <div v-if="flipCardItem.contentTypeId === 2" class="flip-card-back-side-content-item">
                    <b-field label="תמונה:" style="flex: 1;">
                      <input type="url" style="border: 1px solid gray; width: 100%; padding: 14px;" v-model.trim="flipCardItem.imageUrl" placeholder="https://example.com" pattern="https://.*">
                    </b-field>
                    <b-field label="סדר:" style="min-width: 120px;">
                      <input type="number" style="border: 1px solid gray; width: 100%; padding: 14px;" v-model.number="flipCardItem.sortOrder">
                    </b-field>
                    <b-button class="remove-item-btn" @click="removeContentFromBackOfCard(flipCardItem)">הסר תוכן</b-button>
                  </div>
                  
                  <div v-if="flipCardItem.contentTypeId === 3" class="flip-card-back-side-content-item">
                    <b-field label="קישור לוידאו:" style="flex: 1;">
                      <FieldInlineSelect :fetch-options="getVideos" v-model="flipCardItem.videoId" :clearable="true" :initial-option="videoLabelCache[flipCardItem.videoId]"/>
                    </b-field>
                    <b-field label="סדר:" style="min-width: 120px;">
                      <input type="number" style="border: 1px solid gray; width: 100%; padding: 14px;" v-model.number="flipCardItem.sortOrder">
                    </b-field>
                    <b-button class="remove-item-btn" @click="removeContentFromBackOfCard(flipCardItem)">הסר תוכן</b-button>
                  </div>
                  
                  <div v-if="flipCardItem.contentTypeId === 4" class="flip-card-back-side-content-item">
                    <b-field label="קישור לאודיו:" style="flex: 1;">
                      <input type="url" style="border: 1px solid gray; width: 100%; padding: 14px;" v-model.trim="flipCardItem.audioUrl" placeholder="https://example.com" pattern="https://.*">
                    </b-field>
                    <b-field label="סדר:" style="min-width: 120px;">
                      <input type="number" style="border: 1px solid gray; width: 100%; padding: 14px;" v-model.number="flipCardItem.sortOrder">
                    </b-field>
                    <b-button class="remove-item-btn" @click="removeContentFromBackOfCard(flipCardItem)">הסר תוכן</b-button>
                  </div>
                </div>
              </div>
            </template>

            <div class="item" v-if="question.exerciseQuestionTypeId === 6 && flipCardEffectId === 2">
              <b-field label="סוג התוכן:" style="display: flex; align-items: center;  gap: 10px;">
                <FieldInlineSelect key="back-content-type" :hideHover="true" style="border: 1px solid gray; margin-right: 10px;" :filterable="true"
                :clearable="true" :options="getOptionsForBackQuestionCard" v-model="backSideContentType" />
                <b-button @click="addContentToBackOfCard" style="margin-right: 10px;">הוסף תוכן נוסף</b-button>
              </b-field>
            </div>

            <div class="item">
              <b-field label="נושא שאלה לדוחות ניתוח:">
                <FieldInlineSelect :hideHover="true" style="border: 1px solid gray; width: 100%;" :filterable="true"
                  :clearable="true" :optionsAsync="getExerciseSubjects" v-model="question.questionSubjectId" />
              </b-field>
            </div>

            <div class="item">
              <div style="display: flex; align-items: center; margin-bottom: 5px; gap: 5px">
                <span class="bold-text">הגבלת זמן:</span><b-input type="number"
                  v-model="question.timeToRedAlertInSeconds"></b-input>שניות.
                *לאחר זמן מה השעון בתרגול יצבע באדום
              </div>
            </div>

            <div class="item">
              <div style="display: flex; align-items: center;" class="bold-text">
                <b-checkbox class="bold-text" v-model="question.isInExam">האם שאלת אמת</b-checkbox>
              </div>
              <b-input placeholder="MM/YYYY" v-if="question.isInExam" style="width: 30%;" v-model="question.examDate"
                type="text" v-mask="'##/####'"></b-input>
            </div>
            <div class="item">
              <b-checkbox class="bold-text" v-model="question.isDelta">האם שאלת דלתא</b-checkbox>
            </div>
            <div class="item">
              <div style="display: flex; align-items: center;">
                <b-field style="width: 30%" label="רמת חשיבות שאלה:">
                  <FieldInlineSelect :hideHover="true" style="border: 1px solid gray; width: 100%;" :filterable="true"
                    :clearable="true" :options="[{ Value: null, Text: 'חשיבות רגילה' }, { Value: 1, Text: 'חשיבות גבוהה' }]" v-model="question.importanceLevel" />
                </b-field>
              </div>
            </div>

            <div class="item">
              <div style="display: flex; align-items: center;">
                <b-field style="width: 30%" label="ציון העמקה משוקלל:">
                  <b-input type="number" step="0.01" min="0" max="999.99"
                    placeholder="לדוגמה: 93.87"
                    v-model.number="question.weightedEnrichmentScore" />
                </b-field>
              </div>
              <small class="form-text text-muted">
                ערך עשרוני בין 0 ל-100 (עד 2 ספרות אחרי הנקודה). ניתן להשאיר ריק.
              </small>
            </div>

            <div class="item">
              <div style="display: flex; align-items: center; margin-bottom: 5px; gap: 5px">
                <span class="bold-text">מספרי פסקאות:</span>
                <b-input type="number" v-model="question.paragraphNumber1"></b-input>
                <b-input type="number" v-model="question.paragraphNumber2"></b-input>
                <b-input type="number" v-model="question.paragraphNumber3"></b-input>
                <b-input type="number" v-model="question.paragraphNumber4"></b-input>
                <b-input type="number" v-model="question.paragraphNumber5"></b-input>
              </div>
            </div>

            <div class="item">
              <b-field label="סעיפים נכונים:">
                <div style="display: flex; align-items: center; gap: 10px;">
                  <FieldInlineSelect @onChange="searchLawClause" :placeholder="'בחר חוק מהרשימה'" :hideHover="true"
                    style="border: 1px solid gray; width: 30%;" :filterable="true" :clearable="true"
                    :reduce="(law) => law" :optionsAsync="getLaws" v-model="question.law" />
                  <!-- <FieldInlineSelect v-if="question.law" :hideHover="true" style="border: 1px solid gray; width: 30%;"
                    :filterable="true" :clearable="true" :options="lawClauses" v-model="question.clauseId" /> -->
                  <v-select style="min-width: 300px;" v-if="question.law" dir="rtl" v-model="question.clauseId"
                    :filterable="true" :clearable="true" :reduce="item => item"
                    :getOptionLabel="(item) => `${item.Text}`" :options="lawClauses" :searchable="true"
                    :close-on-select="true" :placeholder="'בחר ערך מהרשימה'">
                  </v-select>
                  <button class="new" @click="addLawClause" v-if="question.clauseId">הוסף</button>
                </div>
                <div v-if="question.correctClauses && question.correctClauses.length" class="clauses">
                  <div style="display: flex; align-items: center; gap: 10px; margin-top: 10px"
                    v-for="clause, idx in question.correctClauses" :key="idx" class="clause">
                    <div>{{ clause.lawName }} סעיף: {{ clause.clauseName }}</div>
                    <button @click="removeLawClause(clause.clauseId)">X הסרה</button>
                  </div>
                </div>
              </b-field>
            </div>

            <!-- <div class="item">
              <b-field label="">
                <b-checkbox class="bold-text" v-model="question.status">האם לאפשר פתרון להדפסה</b-checkbox>
                <b-checkbox class="bold-text" v-model="question.status">האם לאפשר שאלון להדפסה</b-checkbox>
              </b-field>
            </div> -->
            
            <div v-if="question.exerciseQuestionTypeId !== 6" class="item">
              <div style="display: flex; gap: 10px;" class="bold-text">
                <span>תשובות</span>
                <span @click="isWordAlt = !isWordAlt" style="color: #337ab7; cursor: pointer;">העתק חלופות</span>
              </div>
              <div v-if="isWordAlt" style="display: flex; gap: 10px;">
                <b-input v-model="wordAltText"></b-input>
                <b-button @click="processingTextToFields(wordAltText)" :disabled="!wordAltText">טעינת חלופות</b-button>
              </div>
            </div>

            <div v-if="question.answers && question.exerciseQuestionTypeId !== 6" v-for="answer, idx in question.answers" :key="idx" class="item">
              <div style="display: flex; align-items: center;" class="bold-text">
                תשובה {{ idx + 1 }}
                <b-checkbox class="bold-text" v-model="answer.isCorrectAnswer">האם נכונה</b-checkbox>
              </div>
              <template>
                <!-- <ckeditor :editor="editor" v-model="answer.answer" :config="editorConfig"></ckeditor> -->
                <NewActivityEditor @onEditorChange="(e) => setAnswer(idx, e)" v-if="ready" :ckEditorContent="answer.answer" :content="answer.answer"
                  ref="editor" :ref="`answerEditor${idx}`" />
              </template>
              <div style="display: flex; gap: 20px;">
                <b-field style="width: 30%;" label="מיומנות:">
                  <FieldInlineSelect :hideHover="true" style="border: 1px solid gray; width: 100%;" :filterable="true"
                    :clearable="true" :optionsAsync="getMeyumanot" v-model="answer.skill" />
                </b-field>
                <b-field style="width: 30%;" label="חומרת שגיאה:">
                  <FieldInlineSelect :hideHover="true" style="border: 1px solid gray; width: 100%;" :filterable="true"
                    :clearable="true" :options="getSeverities" v-model="answer.severity" />
                </b-field>
                <b-field style="width: 60%;" label="הסבר:">
                  <FieldInlineSelect :hideHover="true" style="border: 1px solid gray; width: 100%;" :filterable="true"
                    :clearable="true" :optionsAsync="getExplanations" v-model="answer.explanationId" />
                </b-field>
              </div>
              <div style="cursor: pointer;" @click="toggleShowNoteForAnswer(idx)" class="bold-text">
                {{ showNoteForAnswers[idx] ? `הסתרת הערה לתשובה ${idx + 1}` : `הצגת הערה לתשובה ${idx + 1}` }}
              </div>
              <template>
                <!-- <ckeditor :editor="editor" v-model="answer.remark" :config="editorConfig"></ckeditor> -->
                <NewActivityEditor v-if="showNoteForAnswers[idx] && ready" @onEditorChange="(e) => setRemark(idx, e)" :ckEditorContent="answer.remark" :content="answer.remark"
                  ref="editor" backgroundColor="#EFF5D2" borderColor="#C6D870" />
              </template>
            </div>

            <!-- <div class="item">
              <div style="display: flex; align-items: center;" class="bold-text">
                תשובה 1
                <b-checkbox class="bold-text" v-model="question.answer1IsCorrectAnswer">האם נכונה</b-checkbox>
              </div>
              <ckeditor :editor="editor" v-model="question.answer1Answer" :config="editorConfig"></ckeditor>
              <div style="display: flex; gap: 20px;">
                <b-field style="width: 30%;" label="מיומנות:">
                  <FieldInlineSelect :hideHover="true" style="border: 1px solid gray; width: 100%;" :filterable="true"
                    :clearable="true" :options="[{ Value: 0, Text: 'לא פעיל' }, { Value: 1, Text: 'פעיל' }]"
                    v-model="question.answer1Skill" />
                </b-field>
                <b-field style="width: 30%;" label="חומרת שגיאה:">
                  <FieldInlineSelect :hideHover="true" style="border: 1px solid gray; width: 100%;" :filterable="true"
                    :clearable="true" :optionsAsync="getAcademicInstitudes" v-model="question.answer1Severity" />
                </b-field>
                <b-field style="width: 60%;" label="הסבר:">
                  <FieldInlineSelect :hideHover="true" style="border: 1px solid gray; width: 100%;" :filterable="true"
                    :clearable="true" :optionsAsync="getAuthors" v-model="question.answer1ExplainationId" />
                </b-field>
              </div>
              <div class="bold-text">
                הערה לתשובה
              </div>
              <ckeditor :editor="editor" v-model="question.answer1Remark" :config="editorConfig"></ckeditor>
            </div>

            <div class="item">
              <div style="display: flex; align-items: center;" class="bold-text">
                תשובה 2
                <b-checkbox class="bold-text" v-model="question.answer2IsCorrectAnswer">האם נכונה</b-checkbox>
              </div>
              <ckeditor :editor="editor" v-model="question.answer2Answer" :config="editorConfig"></ckeditor>
              <div style="display: flex; gap: 20px;">
                <b-field style="width: 30%;" label="מיומנות:">
                  <FieldInlineSelect :hideHover="true" style="border: 1px solid gray; width: 100%;" :filterable="true"
                    :clearable="true" :options="[{ Value: 0, Text: 'לא פעיל' }, { Value: 1, Text: 'פעיל' }]"
                    v-model="question.answer2Skill" />
                </b-field>
                <b-field style="width: 30%;" label="חומרת שגיאה:">
                  <FieldInlineSelect :hideHover="true" style="border: 1px solid gray; width: 100%;" :filterable="true"
                    :clearable="true" :optionsAsync="getAcademicInstitudes" v-model="question.answer2Severity" />
                </b-field>
                <b-field style="width: 60%;" label="הסבר:">
                  <FieldInlineSelect :hideHover="true" style="border: 1px solid gray; width: 100%;" :filterable="true"
                    :clearable="true" :optionsAsync="getAuthors" v-model="question.answer2ExplainationId" />
                </b-field>
              </div>
              <div class="bold-text">
                הערה לתשובה
              </div>
              <ckeditor :editor="editor" v-model="question.answer2Remark" :config="editorConfig"></ckeditor>
            </div>

            <div class="item">
              <div style="display: flex; align-items: center;" class="bold-text">
                תשובה 3
                <b-checkbox class="bold-text" v-model="question.answer3IsCorrectAnswer">האם נכונה</b-checkbox>
              </div>
              <ckeditor :editor="editor" v-model="question.answer3Answer" :config="editorConfig"></ckeditor>
              <div style="display: flex; gap: 20px;">
                <b-field style="width: 30%;" label="מיומנות:">
                  <FieldInlineSelect :hideHover="true" style="border: 1px solid gray; width: 100%;" :filterable="true"
                    :clearable="true" :options="[{ Value: 0, Text: 'לא פעיל' }, { Value: 1, Text: 'פעיל' }]"
                    v-model="question.answer3Skill" />
                </b-field>
                <b-field style="width: 30%;" label="חומרת שגיאה:">
                  <FieldInlineSelect :hideHover="true" style="border: 1px solid gray; width: 100%;" :filterable="true"
                    :clearable="true" :optionsAsync="getAcademicInstitudes" v-model="question.answer2Severity" />
                </b-field>
                <b-field style="width: 60%;" label="הסבר:">
                  <FieldInlineSelect :hideHover="true" style="border: 1px solid gray; width: 100%;" :filterable="true"
                    :clearable="true" :optionsAsync="getAuthors" v-model="question.answer3ExplainationId" />
                </b-field>
              </div>
              <div class="bold-text">
                הערה לתשובה
              </div>
              <ckeditor :editor="editor" v-model="question.answer3Remark" :config="editorConfig"></ckeditor>
            </div>

            <div class="item">
              <div style="display: flex; align-items: center;" class="bold-text">
                תשובה 4
                <b-checkbox class="bold-text" v-model="question.answer3IsCorrectAnswer">האם נכונה</b-checkbox>
              </div>
              <ckeditor :editor="editor" v-model="question.answer4Answer" :config="editorConfig"></ckeditor>
              <div style="display: flex; gap: 20px;">
                <b-field style="width: 30%;" label="מיומנות:">
                  <FieldInlineSelect :hideHover="true" style="border: 1px solid gray; width: 100%;" :filterable="true"
                    :clearable="true" :options="[{ Value: 0, Text: 'לא פעיל' }, { Value: 1, Text: 'פעיל' }]"
                    v-model="question.answer4Skill" />
                </b-field>
                <b-field style="width: 30%;" label="חומרת שגיאה:">
                  <FieldInlineSelect :hideHover="true" style="border: 1px solid gray; width: 100%;" :filterable="true"
                    :clearable="true" :optionsAsync="getAcademicInstitudes" v-model="question.answer4Severity" />
                </b-field>
                <b-field style="width: 60%;" label="הסבר:">
                  <FieldInlineSelect :hideHover="true" style="border: 1px solid gray; width: 100%;" :filterable="true"
                    :clearable="true" :optionsAsync="getAuthors" v-model="question.answer4ExplainationId" />
                </b-field>
              </div>
              <div class="bold-text">
                הערה לתשובה
              </div>
              <ckeditor :editor="editor" v-model="question.answer4Remark" :config="editorConfig"></ckeditor>
            </div> -->

            <div class="item">
              <b-field label="הערות עורך:">
                <textarea type="text" v-model="question.editorNotes" style="border: 1px solid gray; width: 30%;"
                  rows="4" cols="50" name="" id=""></textarea>
              </b-field>
            </div>

            <div class="item">
              <div class="bold-text">
                (5 אחרונים) שאלה זו מופיעה בתרגולים
              </div>
              <div v-if="question.firstAppearance" class="question-instance">
                <div class="bold-text">מופע ראשון:</div>
                <a @click="goToExercisePage(question.firstAppearance)">{{ question.firstAppearance.exerciseName }}</a>
                <div>מתוך: {{ question.firstAppearance.lessonName }} בקורס: {{ question.firstAppearance.courseName }}
                </div>
              </div>
              <div class="question-instances">
                <div v-for="instance in question.lastFiveAppearances" :key="instance.id" class="question-instance">
                  <a @click="goToExercisePage(instance)">{{ instance.exerciseName }}</a>
                  <div>מתוך: {{ instance.lessonName }} בקורס: {{ instance.courseName }}</div>
                </div>
              </div>
            </div>

            <div ref="question_save_btn" class="question-save-buttons">
              <b-button type="is-info" class="new flex-2" :class="{ 'disabled': isCorrectAnswersEmpty }" :title="isCorrectAnswersEmpty ? 'יש לבחור לפחות תשובה אחת נכונה!' : ''" @click="handleSaveQuestion">שמירת שינויים</b-button>
              <!-- <b-button type="is-info" class="new flex-2" @click="newQuestion">הוספת שאלה חדשה לבנק השאלות</b-button> -->
            </div>

          </div>
        </div>
      </div>
      <!-- <div v-if="tab === 2">
        <template>
          <div class="Activity__Component__TabsContent__Tasks__Header">
            <div class="new bold-text" @click="newVideo">רמת קושי ממוצעת בתרגול: {{ question.status || 6.5 }}</div>
          </div>
          <div class="section-container">
            <div style="display: flex; gap: 10px; margin-bottom: 10px;">
              <div class="bold-text">שאלות בתרגול</div>
              <b-button style="height: 25px;">הסתר חלופות</b-button>
              <b-button style="height: 25px;">הצג חלופות</b-button>
            </div>
            <small>מספר שאלות: {{ question.questions || 40 }} (*לא ניתן לסדר שאלות לתרגול פעיל)</small>
            <div class="document-table">
              <div class="columns">
                <div class="column">
                  סדר
                </div>
                <div class="column">
                  ID שאלה
                </div>
                <div class="column">
                  שאלה
                </div>
                <div class="column">
                  הערות עורך
                </div>
                <div class="column">
                  רמת קושי
                </div>
                <div class="column">

                </div>
                <div class="column">

                </div>
                <div class="column">

                </div>
              </div>
              <div class="row" v-for="(question, idx) in questionItems" :key="idx">
                <div class="column-item">{{ question.sortOrder }}</div>
                <div class="column-item">{{ question.id }}</div>
                <div class="column-item">{{ question.name }}</div>
                <div class="column-item">{{ question.editor }}</div>
                <div class="column-item">{{ question.difficulty }}</div>
                <div>
                  <b-tooltip type="is-white" label="הגדרות">
                    <a style="color: green;" class="updateItem">
                      <b-icon icon="file"> </b-icon>
                    </a>
                  </b-tooltip>
                </div>
                <div>
                  <b-tooltip type="is-white" label="הגדרות">
                    <a style="color: green;" class="updateItem">
                      <b-icon icon="file"> </b-icon>
                    </a>
                  </b-tooltip>
                </div>
                <div>
                  <b-tooltip type="is-white" label="הגדרות">
                    <a style="color: green;" class="updateItem">
                      <b-icon icon="file"> </b-icon>
                    </a>
                  </b-tooltip>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <b-field label="בחר שאלה">
              <FieldInlineSelect style="width: 30%; background-color: #eee;" :closeOnSelect="false"
                :alert-not-exist="true" :hide-hover="true" label="" :multiple="true" :clearable="true" :filterable="true"
                placeholder="חיפוש חופשי" :options="[]" :fetch-options="onSearchNewQuestions" @onChange="onChange"
                :reduce="(item) => item" v-model="newQuestionIds" />
            </b-field>
          </div>
        </template>
      </div> -->
    </div>
  </div>
</template>

<script>
import moment from "moment";
import FieldInlineSelect from '@/components/Fields/FieldInlineSelect.vue';
import FieldInlineDate from '@/components/Fields/FieldInlineDate.vue';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CoursesService from "@/services/CoursesService";
import vSelect from "vue-select";
import "vue-select/src/scss/vue-select.scss";
import _ from "lodash";
import {
  ModalProgrammatic as Modal,
  ToastProgrammatic as Toast,
  DialogProgrammatic as Dialog
} from "buefy";
import DialogAddExercise from "./DialogAddExercise.vue";
import AdminService from "../services/AdminService";
import NewActivityEditor from "./NewActivityEditor.vue";
import DialogQuestionHistory from "./DialogQuestionHistory.vue";
import { mapMutations } from 'vuex';
import TreeSelect from './TreeSelect.vue';
import TreeItem from './TreeItem.vue';

const {
  ClassicEditor,
  Alignment,
   // Autoformat,  // Disabled to fix asterisk auto-formatting
  Base64UploadAdapter,
  AutoImage,
  AutoLink,
  Autosave,
  BalloonToolbar,
  BlockQuote,
  Bold,
  Bookmark,
  CloudServices,
  Code,
  Essentials,
  FontBackgroundColor,
  FontColor,
  FontFamily,
  FontSize,
  GeneralHtmlSupport,
  Heading,
  Highlight,
  HorizontalLine,
  HtmlComment,
  HtmlEmbed,
  ImageBlock,
  ImageCaption,
  ImageInline,
  ImageInsertViaUrl,
  ImageResize,
  ImageStyle,
  ImageTextAlternative,
  ImageToolbar,
  ImageUpload,
  Indent,
  IndentBlock,
  Italic,
  Link,
  LinkImage,
  List,
  ListProperties,
  //
  MediaEmbed,
  Paragraph,
  PasteFromMarkdownExperimental,
  PasteFromOffice,
  RemoveFormat,
  SpecialCharacters,
  SpecialCharactersArrows,
  SpecialCharactersCurrency,
  SpecialCharactersEssentials,
  SpecialCharactersLatin,
  SpecialCharactersMathematical,
  SpecialCharactersText,
  Strikethrough,
  Style,
  Subscript,
  Superscript,
  Table,
  TableCaption,
  TableCellProperties,
  TableColumnResize,
  TableProperties,
  TableToolbar,
  TextTransformation,
  TodoList,
  Underline,
  FindAndReplace,
  PageBreak,
  ShowBlocks,
  WordCount
} = CKEDITOR;

const { ExportPdf, ExportWord, LineHeight } = CKEDITOR_PREMIUM_FEATURES;

export default {
  name: "Activity",
  components: {
    FieldInlineSelect,
    FieldInlineDate,
    vSelect,
    NewActivityEditor,
    TreeSelect,
    TreeItem,
  },
  props: {
    activities: Array,
    loading: Boolean,
    entityType: String,
    entityId: String,
  },
  // updated() {
  //   const params = window.location.search.substring(1);
  //   const lastIdx = params.lastIndexOf("=");
  //   const taskId = params.slice(lastIdx + 1);
  //   const task = this.$refs[`taskElement${taskId}`][0];
  //   task.isOpen = true;
  //   this.$nextTick(() => {
  //     task.$el.scrollIntoView({ behavior: "smooth" });
  //   });
  // },
  computed: {
    course() {
      return this.$store.state.auth?.course;
    },
    inputVal() {
      return new Date(this.question.examDate);
    },
    getEffectTypes() {
      return [
        { Value: 0, Text: 'שאלה רגילה' },
        { Value: 1, Text: 'Timer' },
        { Value: 2, Text: 'PopUp' },
        { Value: 3, Text: 'HideAnswers' },
        { Value: 4, Text: 'InterferenceQuestion' },
        { Value: 5, Text: 'PopUpQuestionText' },
      ];
    },
    getSeverities() {
      return [
        { Value: 1, Text: '1' },
        { Value: 2, Text: '2' },
        { Value: 3, Text: '3' },
        { Value: 4, Text: '4' },
        { Value: 5, Text: '5' },
      ];
    },
    getOptionsForFlipCardEffect() {
      return [
        { Value: 1, Text: 'חד צדדי' },
        { Value: 2, Text: 'דו צדדי' },
      ];
    },
    getOptionsForBackQuestionCard() {
      // this values are according to the content type id in the database
      const options = [
        { Value: 1, Text: 'טקסט' },
        { Value: 2, Text: 'תמונה' },
        { Value: 3, Text: 'וידאו' },
        { Value: 4, Text: 'אודיו' },
      ];
      return options;
    },
    frontCardVideoItem() {
      return this.question.flipCardItems?.find((item) => item.side === 1 && item.contentTypeId === 3);
    },
    backSideItems() {
      return this.question.flipCardItems?.filter((item) => item.side === 2) || [];
    },
    lesson() {
      return this.$store.state.lesson;
    },
    userName() {
      return `${this.$store.state.user.privateName} ${this.$store.state.user.lastName}`;
    },
    haveNoActivities() {
      return (
        !this.loading &&
        (!this.groupedActivities || !Object.keys(this.groupedActivities).length)
      );
    },
    haveNoNotes() {
      return (
        !this.loading &&
        (!this.groupedActivitiesNotes ||
          !Object.keys(this.groupedActivitiesNotes).length)
      );
    },
    haveNoTasks() {
      return (
        !this.loading &&
        (!this.groupedActivitiesTasks ||
          !Object.keys(this.groupedActivitiesTasks).length)
      );
    },
    groupedActivities() {
      if (this.activities && this.activities.length) {
        const withoutDeleted = this.activities.filter(
          (item) => this.deletedItems.indexOf(item.Id) === -1
        );
        return _.groupBy(withoutDeleted, (item) =>
          moment(item.CreateDate, "YYYY-MM-DDThh:mm").format("MM/YYYY")
        );
      }
      return null;
    },
    groupedActivitiesNotes() {
      if (this.activities && this.activities.length) {
        const withoutDeleted = this.activities.filter(
          (item) =>
            this.deletedItems.indexOf(item.Id) === -1 && item.ItemType === 1
        );
        return _.groupBy(withoutDeleted, (item) =>
          moment(item.CreateDate, "YYYY-MM-DDThh:mm").format("MM/YYYY")
        );
      }
      return null;
    },
    groupedActivitiesTasks() {
      if (this.activities && this.activities.length) {
        const withoutDeleted = this.activities.filter(
          (item) =>
            this.deletedItems.indexOf(item.Id) === -1 && item.ItemType === 2
        );
        return _.groupBy(withoutDeleted, (item) =>
          moment(item.CreateDate, "YYYY-MM-DDThh:mm").format("MM/YYYY")
        );
      }
      return null;
    },
    isCorrectAnswersEmpty() {
      if (this.question.exerciseQuestionTypeId === 6) return false;
      return this.question.answers?.length > 0 && !this.question.answers.some((answer) => answer.isCorrectAnswer);
    },
  },
  data() {
    return {
      isWordAlt: false,
      wordAltText: '',
      tab: 1,
      showNewNote: false,
      showNewTask: false,
      showNoteForAnswers: [false, false, false, false],
      deletedItems: [],
      isLoading: false,
      ready: false,
      videoLabelCache: {},
      categories: [],
      treeCategories: [],
      lawClauses: [],
      showVideoInFrontCard: false,
      backSideContentType: 1,
      flipCardEffectId: 1,
      question: {
        status: 1,
        flipCardItems: []
      },
      questionItems: null,
      laws: null,
      verdicts: null,
      studentAnswers: {},
      newQuestionIds: null,
      editor: ClassicEditor,
      editorConfig: {
        language: 'he',
        toolbar: {
          items: [
            'heading',
            '|',
            'fontSize',
            'fontFamily',
            'fontColor',
            'fontBackgroundColor',
            '|',
            'bold',
            'italic',
            'underline',
            'caseChange',
            'formatPainter',
            '|',
            'link',
            'insertTable',
            'highlight',
            'pageBreak',
            '|',
            'alignment',
            '|',
            'bulletedList',
            'numberedList',
            'todoList',
            'multilevelList',
            'outdent',
            'indent',
            '|',
            'findAndReplace',
            'tableOfContents',
            'showBlocks',
            '|',
            'exportPdf',
            'exportWord'
          ],
          shouldNotGroupWhenFull: false
        },
        plugins: [
          Alignment,
          // Autoformat,  // Disabled to fix asterisk auto-formatting
          Base64UploadAdapter,
          AutoImage,
          AutoLink,
          Autosave,
          BalloonToolbar,
          BlockQuote,
          Bold,
          Bookmark,
          CloudServices,
          Code,
          Essentials,
          FontBackgroundColor,
          FontColor,
          FontFamily,
          FontSize,
          GeneralHtmlSupport,
          Heading,
          Highlight,
          HorizontalLine,
          HtmlComment,
          HtmlEmbed,
          ImageBlock,
          ImageCaption,
          ImageInline,
          ImageInsertViaUrl,
          ImageResize,
          ImageStyle,
          ImageTextAlternative,
          ImageToolbar,
          ImageUpload,
          Indent,
          IndentBlock,
          Italic,
          Link,
          LinkImage,
          List,
          ListProperties,
          //
          MediaEmbed,
          Paragraph,
          PasteFromMarkdownExperimental,
          PasteFromOffice,
          RemoveFormat,
          SpecialCharacters,
          SpecialCharactersArrows,
          SpecialCharactersCurrency,
          SpecialCharactersEssentials,
          SpecialCharactersLatin,
          SpecialCharactersMathematical,
          SpecialCharactersText,
          Strikethrough,
          Style,
          Subscript,
          Superscript,
          Table,
          TableCaption,
          TableCellProperties,
          TableColumnResize,
          TableProperties,
          TableToolbar,
          TextTransformation,
          TodoList,
          Underline,
          ExportPdf,
          ExportWord,
          LineHeight,
          FindAndReplace,
          PageBreak,
          ShowBlocks,
          WordCount,
        ].filter(Boolean),
        balloonToolbar: ['bold', 'italic', '|', 'link', '|', 'bulletedList', 'numberedList'],
        fontFamily: {
          supportAllValues: true
        },
        fontSize: {
          options: [10, 12, 14, 'default', 18, 20, 22],
          supportAllValues: true
        },
        lineHeight: {
          options: ['default', 1, 1.1, 1.25, 1.5, 2, 2.5, 3]
        },
        heading: {
          options: [
            {
              model: 'paragraph',
              title: 'Paragraph',
              class: 'ck-heading_paragraph'
            },
            {
              model: 'heading1',
              view: 'h1',
              title: 'Heading 1',
              class: 'ck-heading_heading1'
            },
            {
              model: 'heading2',
              view: 'h2',
              title: 'Heading 2',
              class: 'ck-heading_heading2'
            },
            {
              model: 'heading3',
              view: 'h3',
              title: 'Heading 3',
              class: 'ck-heading_heading3'
            },
            {
              model: 'heading4',
              view: 'h4',
              title: 'Heading 4',
              class: 'ck-heading_heading4'
            },
            {
              model: 'heading5',
              view: 'h5',
              title: 'Heading 5',
              class: 'ck-heading_heading5'
            },
            {
              model: 'heading6',
              view: 'h6',
              title: 'Heading 6',
              class: 'ck-heading_heading6'
            }
          ]
        },
        htmlSupport: {
          allow: [
            {
              name: /^.*$/,
              styles: true,
              attributes: true,
              classes: true
            }
          ]
        },
        image: {
          toolbar: [
            'toggleImageCaption',
            'imageTextAlternative',
            '|',
            'imageStyle:inline',
            'imageStyle:wrapText',
            'imageStyle:breakText',
            '|',
            'resizeImage'
          ]
        },
        licenseKey: process.env.VUE_APP_CKEDITOR_LICENSE_KEY,
        exportPdf: {
          stylesheets: [
            'https://cdn.ckeditor.com/ckeditor5/44.1.0/ckeditor5.css',
            'https://cdn.ckeditor.com/ckeditor5-premium-features/44.1.0/ckeditor5-premium-features.css'
          ],
          fileName: 'document.pdf',
          converterOptions: {
            format: 'A4',
            margin_top: '20mm',
            margin_bottom: '20mm',
            margin_right: '12mm',
            margin_left: '12mm',
            page_orientation: 'portrait'
          }
        },
        exportWord: {
          stylesheets: [
            'https://cdn.ckeditor.com/ckeditor5/44.1.0/ckeditor5.css',
            'https://cdn.ckeditor.com/ckeditor5-premium-features/44.1.0/ckeditor5-premium-features.css'
          ],
          fileName: 'document.docx',
          converterOptions: {
            format: 'A4',
            margin_top: '20mm',
            margin_bottom: '20mm',
            margin_right: '12mm',
            margin_left: '12mm',
            orientation: 'portrait'
          }
        },
        link: {
          addTargetToExternalLinks: true,
          defaultProtocol: 'https://',
          decorators: {
            toggleDownloadable: {
              mode: 'manual',
              label: 'Downloadable',
              attributes: {
                download: 'file'
              }
            }
          }
        },
        list: {
          properties: {
            styles: true,
            startIndex: true,
            reversed: true
          }
        },
        menuBar: {
          isVisible: true
        },
        placeholder: '',
        style: {
          definitions: [
            {
              name: 'Article category',
              element: 'h3',
              classes: ['category']
            },
            {
              name: 'Title',
              element: 'h2',
              classes: ['document-title']
            },
            {
              name: 'Subtitle',
              element: 'h3',
              classes: ['document-subtitle']
            },
            {
              name: 'Info box',
              element: 'p',
              classes: ['info-box']
            },
            {
              name: 'Side quote',
              element: 'blockquote',
              classes: ['side-quote']
            },
            {
              name: 'Marker',
              element: 'span',
              classes: ['marker']
            },
            {
              name: 'Spoiler',
              element: 'span',
              classes: ['spoiler']
            },
            {
              name: 'Code (dark)',
              element: 'pre',
              classes: ['fancy-code', 'fancy-code-dark']
            },
            {
              name: 'Code (bright)',
              element: 'pre',
              classes: ['fancy-code', 'fancy-code-bright']
            }
          ]
        },
        table: {
          contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells', 'tableProperties', 'tableCellProperties']
        }
      },
    };
  },
  created() {
    console.log("created")
    this.getCategories();
    this.getQuestionCategoriesTree();
    this.loadQuestion();
    this.loadQuestionStudentAnswers();
  },
  methods: {
    ...mapMutations('auth', ['setCourse']),
    onDelete(id) {
      this.deletedItems.push(id);
    },
    goToExercisePage(exercise) {
      this.setCourse({ id: exercise.courseId, name: exercise.courseName });
      const url = this.$router.resolve({ 
        name: "Exercise", 
        params: { id: exercise.exerciseId } 
      }).href;
      window.open(url, "_blank");
      sessionStorage.setItem('scroll', true);
      window.location.reload();
    },
    setQuestion(value) {
      this.question.question = value;
    },
    setDetailed(value) {
      this.question.detailedAnswer = value;
    },
    setAnswer(idx, value) {
      this.question.answers[idx].answer = value;
    },
    setRemark(idx, value) {
      this.question.answers[idx].remark = value;
    },
    onChange() { },
    removeLawClause(clauseId) {
      const idx = this.question.correctClauses.findIndex((c) => c.clauseId === clauseId);
      this.question.correctClauses.splice(idx, 1);
    },
    parseDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm");
    },
    parseTime(time) {
      return `${time.hours <= 9 ? `0${time.hours}` : time.hours}:${time.minutes <= 9 ? `0${time.minutes}` : time.minutes}:${time.seconds <= 9 ? `0${time.seconds}` : time.seconds}`;
    },
    openQuestionHistory() {
      Modal.open({
        component: DialogQuestionHistory,
        customClass: "entity-modal",
        props: {
          name: this.question.name,
          questionId: this.question.id,
          creatorUser: this.question.creatorUserName,
          createdDate: this.question.createdDate
        },
        canCancel: false,
        trapFocus: true,
      });
    },
    onSearchNewQuestions({ search, loading, setData, setValue }) {
      if (search.length > 3) {
        loading(true);
        return AdminService.getQuestionsInBank({
          Terms: search,
          PageSize: 9999,
          IsAscending: false,
          PageNumber: 1,
          ResultType: 3
        })
          .then((r) => {
            if (!r.data.items.length) {
              setValue({ Value: -1, Text: search });
            } else {
              setData(r.data.items.map((i) => ({ Value: i.id, Text: `${i.question} - ${i.id}` })));
            }
          })
          .finally(() => {
            loading(false);
          });
      }

      return null;
    },
    getMeyumanot() {
      return () =>
        CoursesService.getMeyumanot().then((r) =>
          r.data.map((i) => ({ Value: i.id, Text: i.skillname }))
        );
    },
    getExerciseSubjects() {
      return () =>
        CoursesService.getExerciseSubjects().then((r) =>
          r.data.map((i) => ({ Value: i.id, Text: i.subject }))
        );
    },
    getCategories() {
      AdminService.getQuestionCategories().then((r) => {
        this.categories = r.data.map((i) => ({ Value: i.id, Text: i.name }))
      }
      );
      /*CoursesService.getCategories().then((r) => {
        this.categories = r.data.map((i) => ({ Value: i.id, Text: i.name })),
          this.treeCategories = r.data.map((c) => ({ id: c.id, text: c.name }))
      }
      );*/
    },
    getQuestionCategoriesTree() {
      AdminService.getQuestionCategoriesTree().then((r) => {
        this.treeCategories = r.data;
      })
      .catch((error) => {
        console.log("error", error)
      });
    },
    getLaws() {
      return () =>
        CoursesService.getLaws(true).then((r) =>
          r.data.map((i) => ({ Value: i.id, Text: i.dymanicId != null ? i.name + "*" : i.name }))
        );
    },
    getExplanations() {
      return () =>
        CoursesService.getExplanations().then((r) =>
          r.data.map((i) => ({ Value: i.id, Text: i.answerExplenationData }))
        );
    },
    getLawClauses() {
      CoursesService.getLawClauses(this.question.law.Value).then((r) => {
        this.lawClauses = r.data.map((i) => ({ Value: i.id, Text: i.name }));
      });
    },
    addLawClause() {
      this.question.correctClauses.push({
        lawId: this.question.law.Value,
        lawName: this.question.law.Text,
        clauseId: this.question.clauseId.Value,
        clauseName: this.question.clauseId.Text
      });
      this.question.lawId = null;
      this.question.clauseId = null;
    },
    searchLawClause() {
      this.getLawClauses();
    },
    getAcademicInstitudes() {
      return () =>
        AdminService.getAcademicInstitudes().then((r) =>
          r.data.map((i) => ({ Value: i.id, Text: i.name }))
        );
    },
    getAuthors() {
      return () =>
        AdminService.getAuthors().then((r) =>
          r.data.map((i) => ({ Value: i.id, Text: i.name }))
        );
    },
    close() {
      this.showNewNote = false;
    },
    closeTask() {
      this.showNewTask = false;
    },
    newNote() {
      this.showNewNote = true;
    },
    newTask() {
      this.showNewTask = true;
    },
    newQuestion() {
      Modal.open({
        component: DialogAddExercise,
        customClass: "entity-modal",
        props: {

        },
        canCancel: false,
        trapFocus: true,
      });
    },
    handleSaveQuestion() {
      if (this.isCorrectAnswersEmpty) {
        Toast.open({
          type: "is-danger",
          message: "יש לבחור לפחות תשובה אחת נכונה!",
          duration: 8000,
        });
        return;
      }
      if (this.flipCardEffectId === 1 && this.backSideItems.length > 0) {
        console.log("this.flipCardEffectId === 1 && this.backSideItems.length > 0" , this.flipCardEffectId, this.backSideItems.length);
        Dialog.confirm({
          title: "שינוי סוג הכרטיסייה",
          message: "האם להמשיך עם חד צדדי? ימחק כל התוכן בגב הכרטיסייה.",
          confirmText: "המשיך עם חד צדדי",
          cancelText: "ביטול",
          type: "is-warning",
          hasIcon: true,
          onConfirm: () => {
            this.saveQuestion();
          }
        });
        return;
      }
      this.saveQuestion();
    },
    saveQuestion() {
      this.isLoading = true;
      
      // Prepare data for save
      const questionData = { ...this.question };

      if (questionData.weightedEnrichmentScore === '' || questionData.weightedEnrichmentScore === undefined) {
        questionData.weightedEnrichmentScore = null;
      }

      // Clear inappropriate data based on question type
      if (questionData.exerciseQuestionTypeId === 6) {
        // Flip card type - clear traditional answers
        questionData.answers = [];
        if (this.flipCardEffectId === 1 && questionData.flipCardItems.length > 0 && questionData.flipCardItems.some(item => item.side === 2)) {
          questionData.flipCardItems = questionData.flipCardItems.filter(item => item.side === 1);
        }
      } else {
        // Other types - clear flip card items
        questionData.flipCardItems = [];
      }
      
      AdminService.updateQuestion(this.question.id, questionData).then((r) => {
        Toast.open({
          type: "is-success",
          message: "העדכון בוצע בהצלחה!",
          duration: 8000,
        });
        
        window.location.reload();
      }).catch(() => {
        Toast.open({
          type: "is-danger",
          message: "השיוך נכשל!",
          duration: 8000,
        });
      }).finally(() => {
        this.isLoading = false;
      });
    },
    loadQuestion() {
      this.isLoading = true;
      AdminService.getQuestionDetails(this.entityId).then((r) => {
        this.question = r.data;
        // Initialize flipCardItems if doesn't exist (important for EDIT mode)
        if (!this.question.flipCardItems || !Array.isArray(this.question.flipCardItems)) {
          this.$set(this.question, 'flipCardItems', []);
        }
        
        this.loadVideoOptions(this.question.flipCardItems);

        // Set UI state if current type is flip card
        if (this.question.exerciseQuestionTypeId === 6 && this.question.flipCardItems.length > 0) {
          this.showVideoInFrontCard = this.question.flipCardItems.some(item => item.side === 1 && item.contentTypeId === 3);
          const backItems = this.question.flipCardItems.filter(item => item.side === 2);
          this.flipCardEffectId = backItems.length > 0 ? 2 : 1;
        }
        const [p1='', p2='', p3='', p4='', p5=''] = this.question.paragraphNumbers?.split(',') || [];
          this.question.paragraphNumber1 = p1;
          this.question.paragraphNumber2 = p2;
          this.question.paragraphNumber3 = p3;
          this.question.paragraphNumber4 = p4;
          this.question.paragraphNumber5 = p5;
        
        // Set ready flag AFTER all data is initialized
        this.ready = true;
      })
        .finally(() => {
          this.tab = 1;
          this.isLoading = false;
          if (sessionStorage.getItem('scroll')) {
            this.$refs.question_save_btn.scrollIntoView();
            sessionStorage.clear('scroll');
          }
        });
    },
    loadQuestionStudentAnswers() {
      AdminService.getQuestionStudentAnswers(this.entityId).then((r) => {
        this.studentAnswers = r.data;
      });
    },
    loadQuestionItems() {
      this.isLoading = true;
      AdminService.getQuestionDetails(this.$store.state.auth.course?.id, {
        LessonIds: [this.entityId]
      })
        .then((r) => {
          this.questionItems = r.data.items;
        })
        .finally(() => {
          this.tab = 2;
          this.isLoading = false;
        });
    },
    loadLaws() {
      this.isLoading = true;
      AdminService.getAdminLaws(this.$store.state.auth.course?.id, {
        LessonIds: [this.entityId]
      })
        .then((r) => {
          this.laws = r.data.items;
        })
        .finally(() => {
          this.tab = 3;
          this.isLoading = false;
        });
    },
    loadVerdicts() {
      this.isLoading = true;
      AdminService.getAdminVerdicts(this.$store.state.auth.course?.id, {
        LessonIds: [this.entityId]
      })
        .then((r) => {
          this.verdicts = r.data.items;
        })
        .finally(() => {
          this.tab = 4;
          this.isLoading = false;
        });
    },
    parsedGroupedDate(date) {
      if (date) {
        const localLocale = moment(date, "MM/YYYY");
        localLocale.locale("he");
        return localLocale.format("MMMM YYYY");
      }
      return null;
    },
    processingTextToFields(text) {
      if (!text) return;
      const strParts = text.split('\t').slice(1); // remove the first part, not needed
      if (strParts.length >= 4) {
        strParts.forEach((part, index) => {
          const cleanPart = part.replace(/[א-ד]\.\s*$/, '').trim() // remove the letter and the dot
          this.$refs[`answerEditor${index}`][0].setData(cleanPart); // update the editor
          this.setAnswer(index, cleanPart); // update the data model
        });
      } else {
        Toast.open({
          type: "is-danger",
          message: "שגיאה! הטקסט צריך להכיל 4 חלקים לפחות!",
          duration: 8000,
        });
      }
    },
    toggleShowNoteForAnswer(idx) {
      this.$set(this.showNoteForAnswers, idx, !this.showNoteForAnswers[idx]);
    },
    toggleShowVideoInFrontCard() {
      if (this.showVideoInFrontCard) {
        // Add video to FRONT of array (side: 1 should always be first)
        this.question.flipCardItems.unshift({
          side: 1,
          contentTypeId: 3,
          textContent: null,
          imageUrl: null,
          videoId: null,
          audioUrl: null,
          sortOrder: 1,
        });
      } else {
        // Remove front video item
        const idx = this.question.flipCardItems.findIndex((i) => i.side === 1 && i.contentTypeId === 3);
        if (idx !== -1) {
          this.question.flipCardItems.splice(idx, 1);
        }
      }
    },
    getVideos({ search, loading, setData }) {
        if (search.length > 1) {
            loading(true);
            return AdminService.getVideosInBank({
                Terms: search,
                PageSize: 100,
                IsAscending: false,
                PageNumber: 1
            }).then((r) => {
                if (!r.data.items.length) {
                    setData([]);
                } else {
                    setData(r.data.items.map((i) => ({ Value: i.id, Text: `${i.id} - ${i.name}` })));
                }
            }).finally(() => {
                loading(false);
            });
        }
        return null;
    },
    loadVideoOptions(flipCardItems) {
      if (!flipCardItems) return;
      flipCardItems.filter(item => item.videoId && !this.videoLabelCache[item.videoId]).forEach(item => {
        AdminService.getVideosInBank({ EntityId: item.videoId }).then(r => {
          if (r.data.items.length) {
            const v = r.data.items[0];
            this.$set(this.videoLabelCache, item.videoId, { Value: v.id, Text: `${v.id} - ${v.name}` });
          }
        });
      });
    },
    removeContentFromBackOfCard(item) {
      const idx = this.question.flipCardItems.indexOf(item);
      if (idx !== -1) {
        this.question.flipCardItems.splice(idx, 1);
        Toast.open({
          type: "is-success",
          message: "התוכן הוסר בהצלחה!",
          duration: 8000,
        });
      }
    },
    getNewFlipCardItem() {
      return {
        side: null,
        contentTypeId: null,
        textContent: null,
        imageUrl: null,
        videoId: null,
        audioUrl: null,
        sortOrder: null,
      };
    },
    addContentToBackOfCard() {
      const newFlipCardItem = this.getNewFlipCardItem();
      newFlipCardItem.side = 2;
      newFlipCardItem.contentTypeId = this.backSideContentType;
      if (this.question.flipCardItems.length === 0) {
        newFlipCardItem.sortOrder = 1;
      } else {
        newFlipCardItem.sortOrder = this.question.flipCardItems.length + 1;
      }
      this.question.flipCardItems.push(newFlipCardItem);
    },
  },
  watch: {
    'question.exerciseQuestionTypeId': {
      handler(newVal, oldVal){
        // Changing FROM flip card (6) to another type
        if (newVal !== 6 && oldVal === 6) {
          if (this.question.flipCardItems && this.question.flipCardItems.length > 0) {
            const confirmed = confirm('שינוי סוג השאלה ימחק את תוכן הכרטיסייה בעת השמירה. האם להמשיך?');
            if (!confirmed) {
              this.$nextTick(() => {
                this.question.exerciseQuestionTypeId = 6;
              });
              return;
            }
          }
        }
        
        // Changing TO flip card (6) from another type
        if (newVal === 6 && oldVal !== 6) {
          if (this.question.answers && this.question.answers.some(a => a.answer)) {
            const confirmed = confirm('שינוי לסוג כרטיסייה ימחק את התשובות בעת השמירה. האם להמשיך?');
            if (!confirmed) {
              this.$nextTick(() => {
                this.question.exerciseQuestionTypeId = oldVal;
              });
              return;
            }
          }
          // Initialize flip card items if needed
          if (!this.question.flipCardItems || this.question.flipCardItems.length === 0) {
            this.$set(this.question, 'flipCardItems', []);
          }
          // Update UI state
          if (this.question.flipCardItems.length > 0) {
            this.showVideoInFrontCard = this.question.flipCardItems.some(item => item.side === 1 && item.contentTypeId === 3);
            const backItems = this.question.flipCardItems.filter(item => item.side === 2);
            this.flipCardEffectId = backItems.length > 0 ? 2 : 1;
          }
        }
      }
    },
    'flipCardEffectId': {
      handler(newVal, oldVal) {
        if (newVal === 2 && oldVal === 1) {
          // Only add a back side item if one doesn't exist
          const hasBackSideItem = this.question.flipCardItems.some(item => item.side === 2);
          if (!hasBackSideItem) {
            this.question.flipCardItems.push({
              side: 2,
              contentTypeId: 1,
              textContent: null,
              imageUrl: null,
              videoId: null,
              audioUrl: null,
              sortOrder: 1,
            });
          }
        }
        if (newVal === 1 && oldVal === 2 && this.question.flipCardItems.length === 2) {
          this.question.flipCardItems.pop();
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
.Activity__Component {
  background-color: #fff;
}

::v-deep .row_data span {
  margin-left: 5px;
}

.question-details {
  display: flex;
  margin-top: 20px;
  // justify-content: space-between;
}

.question-detail {
  display: flex;
  align-items: center;
  gap: 5px;

  p {
    width: 350px;
  }
}

.question-instance {
  display: flex;
  align-items: center;
  gap: 10px;
}

.question-buttons {
  display: flex;
  justify-content: space-between;
}

.item {
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;
  padding: 20px 10px;
  background-color: white;
}

.bold-text {
  font-weight: bold;
}

.Activity__Component__Tabs {
  display: flex;
  border-bottom: 1px solid #cbd6e2;
  margin: 0px 20px;
  position: sticky;
  top: 0px;
  z-index: 2;
  background-color: #fff;
  padding-top: 6px;

  .Activity__Component__Tabs__Item {
    padding: 15px 25px;
    position: relative;
    cursor: pointer;
    font-size: 15px;

    &:not(.active):hover {
      color: #4188b7;
    }

    &.active:after {
      content: "";
      width: 100%;
      position: absolute;
      z-index: 2;
      bottom: -3px;
      background-color: #2e3f50;
      height: 5px;
      right: 0;
      border-radius: 3px;
    }
  }
}

.section-container {
  display: flex;
  flex-direction: column;
  margin: 0 2% 50px 3%;

  // overflow-x: hidden;
  // align-items: center;
  &:last-child {
    // margin: 0 5% 0 5%;
  }

  img {
    height: 15px;
    margin: 0 2px;
  }

  h1 {
    // margin: 0 2%;
    // width: 15%;
    color: #1eb2d0;
    font-size: 17px;
    font-weight: 700;
    text-align: center;
  }

  p {
    padding: 0px 1%;
    width: 83%;
    // overflow: hidden;
    // text-overflow: ellipsis;
    word-break: break-word;

    ::v-deep .title {
      display: none;
    }
  }

  .workplan {
    display: flex;
    flex-direction: column;

    span {
      // display: flex;
      // align-items: center;
      width: fit-content;
    }

  }
}

.document-table-title-container {
  display: flex;
  justify-content: space-between;
  align-content: center;
  align-items: center;

  // margin-bottom: 25px;
  .document-table-title {
    color: #1eb2d0;
    font-size: 17px;
    font-weight: 700;
  }

  .label-upload-file {
    margin-left: 20px;
    font-weight: 500;
    background-color: transparent;
    border: none;
    color: #57b7ca;
    cursor: pointer;
  }
}

.document-table {
  display: table;
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 70px;
  border: 1px solid #d2d2d2;
  background-color: #fff;
  padding: 5px;
  margin-top: 15px;

  .columns {
    font-weight: bold;
    background-color: #E98F12;
    text-align: center;
  }

  .columns,
  .row {
    display: table-row;
    border-bottom: 1px solid #d2d2d2;
    margin: 0;

    .removeItem,
    .updateItem {
      text-decoration: underline;
    }

    &>div {
      display: table-cell;
      padding: 10px 5px;
      font-size: 14px;
      vertical-align: middle;
    }

    .Table_Field {
      min-width: 170px;
    }
  }
}

.Activity__Component__TabsContent {
  padding: 20px 30px;
  background-color: #eeeeee;

  & .Activity__Item {
    margin: 8px 0;
  }
}

.loading {
  max-height: 300px;
  width: 600px;
  margin: 0 auto;
}

.no-activities {
  font-size: 25px;
  text-align: center;
  opacity: 0.8;

  span {
    margin-top: 50px;

    ::v-deep .mdi-timeline-text-outline {
      &::before {
        font-size: 50px;
      }
    }
  }
}

button.new {
  background-color: #3b5671;
  color: white;
  border: none;
  border-radius: 3px;
  padding: 8px 18px;
  // cursor: pointer;

  &:active {
    transform: scale(0.98);
  }

  &:hover {
    background-color: #4d6782;
  }
}

.question-save-buttons {
  display: flex;
  justify-content: space-around;
  width: 30%;
  gap: 20px;
  margin-top: 15px;
  .disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.flex-1 {
  flex: 1;
}

.flex-2 {
  flex: 2;
}

.Activity__Component__TabsContent__Tasks__Header {
  display: flex;
  justify-content: flex-end;
}

.Activity__Component__TabsContent__Tasks__Content {
  h1 {
    text-align: center;
  }
}

.flip-card-back-container{
  border: 2px solid #cbd6e2;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 15px;
  background-color: #f9fafb;
  
  .flip-card-item-side {
    background-color: #e0e7ef;
    padding: 12px;
    border-radius: 5px;
    font-weight: bold;
    margin-bottom: 15px;
    text-align: center;
    font-size: 16px;
  }
}

.flip-card-back-side-content-item{
  display: flex;
  gap: 10px;
  background-color: white;
  padding: 15px;
  margin-bottom: 12px;
  align-items: flex-start;
  border: 1px solid #e0e7ef;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  
  ::v-deep .field {
    margin-bottom: 0;
  }
  
  .remove-item-btn {
    margin-top: 28px;
  }
  
  &:last-child {
    margin-bottom: 0;
  }
}
</style>
